<div class="section-header" mat-dialog-title>
  <mat-icon class="section-icon">error</mat-icon>
  <span class="section-title">{{ 'general.error' | transloco }}</span>
  <button mat-icon-button class="ss-dialog-close-btn" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
  @if (data.status) {
    <p>
      <b>Status Code: {{ data.status }}</b>
    </p>
  }
  <p>Something went wrong!</p>
  <p class="error-message">
    {{ data?.message }}
  </p>
</div>
<label id="example-radio-group-label">quiet this dialog for seconds:</label>
<mat-radio-group (close)="onClose()" aria-labelledby="example-radio-group-label" class="example-radio-group" [(ngModel)]="quiteTimeVal">
  @for (sec of seconds; track sec) {
    <mat-radio-button class="example-radio-button" [value]="sec">
      {{sec}} seconds
    </mat-radio-button>
  }
</mat-radio-group>
close in: {{timerValue}}
<!--<div>Your favorite season is: {{favoriteSeason}}</div>-->
<div mat-dialog-actions>
  <button mat-raised-button mat-dialog-close color="primary" (click)="onClose()">Close</button>
</div>
